import { render, staticRenderFns } from "./Bmap.vue?vue&type=template&id=cff52c34&scoped=true&"
import script from "./Bmap.vue?vue&type=script&lang=js&"
export * from "./Bmap.vue?vue&type=script&lang=js&"
import style0 from "./Bmap.vue?vue&type=style&index=0&id=cff52c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff52c34",
  null
  
)

export default component.exports